import { z } from 'zod';

export const updateRecommendationSchema = z.object({
  short_content: z.string().min(1, 'Short content is required').optional(),
  deep_content: z.string().optional(),
  threshold_min: z.number().min(0).max(100).optional().nullable(),
  threshold_max: z.number().min(0).max(100).optional().nullable(),
  category_id: z.string().min(1, 'Category ID is required').optional(),
});

export type UpdateRecommendationPayload = z.infer<typeof updateRecommendationSchema>;

export const updateRecommendationParamsSchema = z.object({
  recommendation_id: z.string().min(1, 'Recommendation ID is required'),
});

export type UpdateRecommendationParamsPayload = z.infer<typeof updateRecommendationParamsSchema>;
